import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=2251b17d&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=2251b17d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251b17d",
  null
  
)

export default component.exports